// extracted by mini-css-extract-plugin
export default {"asideUl":"aside_asideUl__aS+K7","asideLink":"aside_asideLink__jiQbZ","navLinkName":"aside_navLinkName__5JxmM"};